import React, { useCallback, useEffect, useState } from "react";

import DashboardGreeting from "../DashboardGreeting";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import AddIcon from "../../assets/images/addIcon.svg";
import AddPolicy from "../HR/AddPolicy";
import { useStateContext } from "../../contexts/ContextProvider";
import CompanyPolicyService from "../../services/companyPolicy.service";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditPolicy from "../HR/EditPolicy";

const CompanyPolicies = ({ user }) => {
  const navHeading = "Company Policies";

  const { policy, setPolicy, windowHeight, setWindowHeight } =
    useStateContext();

  const [policies, setPolicies] = useState([]);

  const [editPolicy, setEditPolicy] = useState(false);

  const [policyData, setPolicyData] = useState({});

  const fetchAllPolicies = useCallback(() => {
    CompanyPolicyService.getAllCompanyPolicies()
      .then((resp) => {
        setPolicies(resp.data);
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    fetchAllPolicies();
  }, [fetchAllPolicies]);

  useEffect(() => {
    let h = window.innerHeight;
    // console.log("height", h);
    setWindowHeight(h - 150);
  });

  return (
    <>
      <div className="dashboard-container">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <div className="filterBar mb-4">
          {user.role === "1" ? (
            <div className="action">
              <button
                className="apply feedback"
                onClick={(e) => {
                  setPolicy(true);
                }}
              >
                <span>
                  <img src={AddIcon} alt="" />
                </span>
                <span>Add New Policy</span>
              </button>
            </div>
          ) : (
            <>&nbsp;</>
          )}
        </div>
        <ToastContainer />
        <Tabs className="react-tabs vertical">
          <TabList style={{ overflow: "scroll", height: windowHeight }}>
            {Array.isArray(policies)
              ? policies.map((item) => {
                  return (
                    <Tab key={item.id}>
                      <div className="tab-text">{item.title}</div>
                    </Tab>
                  );
                })
              : null}
          </TabList>

          {Array.isArray(policies)
            ? policies.map((item) => {
                return (
                  <TabPanel key={item.id}>
                    <h2>{item.title}</h2>
                    <p>{item.description}</p>
                    <iframe
                      src={`https://elmsbk.aeontechhub.com/documents/${item.attchdoc}`}
                      width="100%"
                      height="450px"
                      style={{ border: "none" }}
                      title="PDF Viewer"
                    />
                    <div className="action">
                      <a
                        href={`https://elmsbk.aeontechhub.com/documents/${item.attchdoc}`}
                        target="__blank"
                      >
                        <button className="btn outline">View</button>
                      </a>

                      {user.role === "1" && (
                        <button
                          className="btn fill"
                          onClick={(e) => {
                            setEditPolicy(true);
                            setPolicyData(item);
                          }}
                        >
                          Update
                        </button>
                      )}
                    </div>
                  </TabPanel>
                );
              })
            : null}
        </Tabs>
        <div
          className={`${policy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setPolicy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <AddPolicy fetchAllPolicies={fetchAllPolicies} />
          </div>
        </div>
        <div
          className={`${editPolicy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setEditPolicy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <EditPolicy
              editPolicy={editPolicy}
              setEditPolicy={setEditPolicy}
              policyData={policyData}
              fetchAllPolicies={fetchAllPolicies}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyPolicies;
